import { TYPOGRAPHY_SIZE, Typography } from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useGetKWPConnectionByUserId } from 'src/hooks/interfaces/kwp/get-kwp-connection.hook';
import { generateCodeChallenge, generateCodeVerifier } from 'src/common/helpers/common.helpers';
import { useCheckIfTokenIsValid } from 'src/hooks/interfaces/kwp/check-token-validation.hook';
import { CONNECTION_MODALS } from './kwp/components/modals/modals.enums';
import CreateKWPConnectionModal from './kwp/components/modals/create-kwp-connection.modal.component';
import EditKWPConnectionModal from './kwp/components/modals/edit-kwp-connection.modal.component';
import KWPBoxExpand from './kwp/components/box-expand/kwp-box-expand.component';
import { BodyContainer, HeaderContainer, MainContainer } from './interfaces.styles';

const Interfaces = () => {
  const { t } = useTranslation('common');

  const [activeModal, setActiveModal] = useState<null | string>(null);

  const connectionData = useGetKWPConnectionByUserId();
  const { isTokenValid } = useCheckIfTokenIsValid(connectionData.interfaceConnection?.link);

  const codeVerifier = generateCodeVerifier();
  const codeChallenge = generateCodeChallenge(codeVerifier);

  const canEdit = connectionData.interfaceConnection && isTokenValid;

  return (
    <MainContainer>
      {activeModal === CONNECTION_MODALS.createConnection && (
        <CreateKWPConnectionModal
          onClose={() => setActiveModal(null)}
          codeChallenge={codeChallenge}
          codeVerifier={codeVerifier}
        />
      )}
      {activeModal === CONNECTION_MODALS.editConnection && (
        <EditKWPConnectionModal
          onClose={() => setActiveModal(null)}
          connectionData={connectionData}
          codeChallenge={codeChallenge}
          codeVerifier={codeVerifier}
        />
      )}
      <HeaderContainer>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('labels.interfaces')}
        </Typography>
      </HeaderContainer>
      <BodyContainer>
        <KWPBoxExpand
          createElement={() =>
            canEdit
              ? setActiveModal(CONNECTION_MODALS.editConnection)
              : setActiveModal(CONNECTION_MODALS.createConnection)
          }
          canEdit={canEdit}
        />
      </BodyContainer>
    </MainContainer>
  );
};

export default Interfaces;
